export const TEAM_MEMBERS = [
  {
    id: 1,
    name: "Christophe Borbiconi",
    role: "Directeur d'agence",
    description: "Expert immobilier depuis plus de 20 ans, Christophe a fondé Avantis Immobilier avec la volonté de placer l'humain au cœur de chaque transaction. Sa connaissance parfaite du marché luxembourgeois est un atout majeur pour votre projet.",
    image: "https://img.netty.immo/company56396pba/assets/nego/001_l.jpg?1768466612",
    phone: "+352 671 260 273",
    email: "contact@avantis-immo.lu"
  },
  {
    id: 4,
    name: "Mélanie Pineiro",
    role: "Consultante Immobilier",
    description: "Pour moi, l'immobilier est avant tout une aventure humaine. Spécialisée sur le marché luxembourgeois et frontalier, je m'implique totalement dans votre projet. Formons ensemble une équipe pour atteindre votre but avec sérieux, écoute et bienveillance.",
    image: "https://img.netty.immo/company56396pba/assets/nego/111_l.jpg?1774353121",
    phone: "+352 671 260 273",
    email: "melanie@avantis-immo.lu"
  }
];

export const AGENCY_HISTORY = {
  title: "Notre Histoire",
  content: [
    "Fondée sur des valeurs de transparence et de proximité, Avantis Immobilier s'est imposée comme une référence de l'immobilier au Luxembourg.",
    "Depuis notre création, nous avons accompagné de nombreuses familles dans leurs projets de vie au Grand-Duché. Notre agence n'est pas seulement un lieu de transaction, c'est un partenaire de confiance qui comprend les enjeux spécifiques du marché luxembourgeois.",
    "Aujourd'hui, nous continuons d'innover avec des outils modernes tout en gardant l'ADN qui a fait notre succès : un accompagnement sur-mesure et une expertise sans faille."
  ]
};
